import axios from 'axios';

export const loadRoles = () =>
    axios.get('roles.json').then(response => response.data);
